export default __webpack_public_path__ + "static/media/closet3-480w.ad065c53.png";